module.exports = __webpack_public_path__ + "./Jane_6c07615e058b4ed6a04eba9c0d451a0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2019/Jane.jpg
// module id = 482
// module chunks = 0